<template>
  <div class="container">
    <div class="left">
      <div style="display: flex; align-items: center;margin-bottom: 8px;">
        <div style="width: 76px; text-align: right;">{{$t("page_cps_month_select")}}:</div>
        <div style="flex:1;margin-left: 8px;">
          <a-month-picker style="width: 100%;" v-model="currentDate" :format="monthFormat" :valueFormat="dateFormat" />
        </div>
      </div>
      <div style="height: calc(100% - 78px);border: 1px solid #e9e9e9;margin-bottom: 8px;">
        <Tree @setCheckedKeys="setCheckedKeys" @setIds="setIds" :checked-keys="checkedKeys" :tree-data="treeData" />
      </div>
      <div style="text-align: right;padding-right: 8px;">
        <a-button type="primary" @click="search">
          {{ $t('page_time_analysis_search') }}
        </a-button>
      </div>
    </div>
    <div class="right">
      <div style="display: flex; justify-content: space-between;margin-bottom: 10px;">
        <div>
          <a-button v-acl="'page_ops_work_record_chart_person_export'" type="info" @click="exportExcel">{{this.$t('page_product_export')}}</a-button>
        </div>
        <a-radio-group v-model="radioValue">
          <a-radio-button value="chart">
            {{this.$t('page_work-record_chart')}}
          </a-radio-button>
          <a-radio-button value="table">
            {{this.$t('page_operation_statistics_tablechart')}}
          </a-radio-button>
        </a-radio-group>
      </div>
      <div v-show="radioValue==='chart'" style="height: calc(100% - 42px); border: 1px solid #d7d7d7;">
        <div class="item">
          <div class="title">{{$t('page_cps_bar_month')}}</div>
          <div style="height: calc( 100% - 21px);overflow:hidden">
            <chart-view  width="100%" height="100%" :chart-option="barOption" id="mixedLineAndBar" />
          </div>
        </div>
        <div class="item">
          <div class="title">{{$t('page_cps_pie_month')}}</div>
          <div style="height: calc( 100% - 21px)">
            <chart-view width="100%" height="100%" :chart-option="pieOption" id="pie" />
          </div>
        </div>
      </div>
      <ml-table
        v-show="radioValue==='table'"
        :columns="columns"
        :dataSource="dataSource"
        rowKey="id"
        :scroll="{ y: `calc(100vh - 170px)` }"
      />
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import moment from 'moment';
import Tree from "./components/tree"
import chartView from "@/components/chart/index.vue"
import options from "@/components/chart/index"
import { WorkRecordServiceProxy,WorkRecordStatisticsServiceProxy } from '@/service-proxies/app-v2/work-record.service-proxies'
import { OrganizationServiceProxy } from '@/service-proxies/app-v2/system.service-proxies'
const sysApi = new OrganizationServiceProxy();
const wrsp = new WorkRecordServiceProxy()
const workRecordStatisticsServiceProxy = new WorkRecordStatisticsServiceProxy()
import { exportCustomerStatistic } from "@/api/api";
export default {
  components: { Tree, chartView },
  data() {
    return {
      pieOption : {},
      barOption: {},
      dateFormat: 'YYYY-MM-DD',
      monthFormat: 'YYYY-MM',
      currentDate: '',
      userIdList: [],
      checkedKeys: [],
      treeData: [],
      radioValue: 'chart',
      dataSource: [],
      scrollY: 0,
      xAxis: [],
      numberArr: [],
      timeArr: [],
      pieData: [],
      yAxis: [{min:'auto', max: 'auto', interval: 'auto'}, { min:'auto', max: 'auto', interval: 'auto'}],
    }
  },
  created() {
    this.currentDate = this.moment(new Date()).format('YYYY-MM-DD');
    this.getTreeList();
  },
  watch: {
    'lang'() {
      setTimeout(() => {
        // 异步
        this.draw();
      }, 0);
    }
  },
  computed: {
    ...mapGetters(['lang']),
    columns() {
      return [
        {
          title: this.$t('page_work_record_engineer_name'),
          dataIndex: 'userName',
          ellipsis: true,
          key: 'userName',
        },
        {
          title: this.$t('page_work_record_handle_total_number'),
          dataIndex: 'workRecordNumber',
          ellipsis: true,
          key: 'workRecordNumber',
        },
        {
          title: this.$t('page_work_record_handle_time'),
          dataIndex: 'timeConsuming',
          ellipsis: true,
          key: 'timeConsuming',
        },
        {
          title: this.$t('page_work_record_percent'),
          dataIndex: 'workRecordProportion',
          ellipsis: true,
          key: 'workRecordProportion',
        }
      ]
    },
    barLegend() {
      return [ 
        { name: this.$t('page_work_number'), tooltip: this.$t('page_work_unit_number') },
        { name: this.$t('page_work_handle_time'), tooltip: this.$t('page_work_unit_hour') }
      ]
    }
  },
  methods: {
    moment, 
    // download
    exportExcel() {
      const p = {currentDate: this.currentDate,userIdList: this.userIdList};
      exportCustomerStatistic(p).then(res=>{
        // 创建隐藏的可下载链接
        var a = document.createElement('a')
        a.download = `${this.$t('page_ops_work_record_chart_person')}.xlsx`
        a.style.display = 'none'
        // 字符内容转变成blob地址
        // var blob = new Blob([res])
        let url = URL.createObjectURL(res)
        a.href = url
        // 触发点击
        document.body.appendChild(a)
        a.click()
        // 然后移除
        URL.revokeObjectURL(url)
        document.body.removeChild(a)
      })
    },
    // tree
    async getTreeList() {
      const { data } = await sysApi.userTree();
      const { arr, temp, keys } = this.handleData(data);
      this.checkedKeys = keys;
      this.userIdList = temp;
      this.treeData = arr;
      this.drawChart(temp);

    },
    handleData(arr) {
      var temp = [];
      var keys= [];
      var forFn = function (list) {
        for (let i = 0; i < list.length; i++) {
          let item = list[i];
          item.key= item.parentId +'-'+item.id;
          keys.push(item.key);
          if(item.user) {
            temp.push(item.id);
          }
          if (item.children) {
            forFn(item.children);
          }
        }
      };
      forFn(arr);
      return {arr, temp, keys};

    },
    setCheckedKeys(data) {
      this.checkedKeys= data;
    },
    setIds(data) {
      this.userIdList= data;
    },
    search() {
      this.drawChart(this.userIdList);
    },
    drawChart(userIdList) {
      this.xAxis = [];
      this.numberArr = [];
      this.timeArr = [];
      this.pieData = [];
      const p = {currentDate: this.currentDate,userIdList};
      workRecordStatisticsServiceProxy.getHandlerWorkRecordStatistics(p).then(res=>{
        res.forEach(v=>{
          // bar
          this.xAxis.push(v.userName);
          this.numberArr.push(v.workRecordNumber);
          this.timeArr.push(v.timeConsuming);

          // pie
          if(v.workRecordNumber>0) {
            const name = v.userName +'-'+ v.workRecordProportion;
            this.pieData.push({name, value: v.workRecordNumber});
          }

          // table
          this.dataSource = res;
        });
        // calc yAxis
        this.yAxisCalc();
        this.draw();
      })
    },
    yAxisCalc() {
      let numberMax =Math.max(...this.numberArr);
      let timeMax = Math.max(...this.timeArr);
      let yAxis = [];
      if(numberMax % 5 !== 0) {
        numberMax = Math.ceil(numberMax/5)*5;
      }
      if(timeMax % 5 !== 0) {
        timeMax = Math.ceil(timeMax/5)*5;
      }
      yAxis = [
        { min: 0, max: numberMax, interval:  numberMax / 5 },
        { min: 0, max: timeMax, interval: timeMax / 5 } 
      ];
      this.yAxis = yAxis;
    },
  draw() {
    this.pieOption = options.pie(this.pieData);
    this.barOption = options.mixedLineAndBar(this.barLegend, this.xAxis, this.yAxis, this.numberArr, this.timeArr);
  },
  }
}
</script>
<style lang="less" scoped>
.container{
  display: flex;
  width: 100%;
  height: 100%;
  background-color: #f0f2f5;
  padding-bottom: 0px;
}
.left{
  background: #ffffff;
  min-width: 310px;
  width: 310px;
  height: 100%;
  border: 1px solid #d7d7d7;
  padding: 8px;
}
.right{
  margin-left: 10px;
  flex: 1;
  width: 1px;
  height: 100%;
}
.item{
  height: 50%;
  padding: 10px;
  background: #ffffff;
  &:first-child{
    border-bottom: 1px solid #d7d7d7;
  }
}
</style>